import packageInfo from '../../package.json';
export default packageInfo.version;



// WEBPACK FOOTER //
// ./components/version/index.tsx